import React from "react";

import { useValuationManagerContext } from "../ValuationManagerContext";

export const VehicleHeader: React.FC = () => {
  const { appInput, vehicleDetails } = useValuationManagerContext();
  return (
    <>
      {vehicleDetails && appInput && (
        <div className="alert alert-info">
          {`${appInput.vrm} - ${vehicleDetails.make} ${vehicleDetails.model} ${vehicleDetails.derivative} ${vehicleDetails.colour} ${vehicleDetails.year} with ${vehicleDetails.owners} owners`}
        </div>
      )}
    </>
  );
};
